import { render, staticRenderFns } from "./icon_badge.vue?vue&type=template&id=3c4ae75d&scoped=true&"
import script from "./icon_badge.vue?vue&type=script&lang=js&"
export * from "./icon_badge.vue?vue&type=script&lang=js&"
import style0 from "./icon_badge.vue?vue&type=style&index=0&id=3c4ae75d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4ae75d",
  null
  
)

export default component.exports